import { render } from "./TaskUpdateModal.vue?vue&type=template&id=33eae094&scoped=true&ts=true"
import script from "./TaskUpdateModal.vue?vue&type=script&lang=ts"
export * from "./TaskUpdateModal.vue?vue&type=script&lang=ts"

import "./TaskUpdateModal.vue?vue&type=style&index=0&id=33eae094&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33eae094"]])

export default __exports__